import { observer } from "mobx-react-lite"

import { useScaleApplication } from "@/domains/application/use-scale-application"
import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { AvailableRevenueSources } from "@/domains/vote-page/components/available-revenue-sources"
import { CastYourVoteCard } from "@/domains/vote-page/components/cast-your-vote-card"
import { SuperVoter } from "@/domains/vote-page/components/supervoter"

const VotePage = observer(() => {
  const scaleApp = useScaleApplication()

  if (!scaleApp) {
    return null
  }

  const title = `Cast your votes`

  return (
    <PageContainer>
      <MetaData title={title} />
      <PageTitle title={title} />
      <div className="flex flex-col gap-6">
        <div className="mb-8 flex flex-col gap-6 xl:flex-row">
          <CastYourVoteCard />
          <SuperVoter />
        </div>
        <AvailableRevenueSources />
      </div>
    </PageContainer>
  )
})

export default VotePage
